import React from 'react';

import SocialLink from './Social';
import LinkedInIcon from '../icons/LinkedIn';

import classes from '../Footer.scss';

export default function LinkedInLink(props) {
  return (
    <SocialLink
      href  = "https://www.linkedin.com/company/cityads-media/"
      title = "LinkedIn"
      {...props}
    >
      <LinkedInIcon className={classes.socialIcon} />
    </SocialLink>
  );
}